(function () {
  'use strict';
  if (window.NimallContinuous) return;
  const mobile = matchMedia('(max-width: 767px)');
  const controllers = new Map();
  const ar = document.documentElement.lang.startsWith('ar');
  const words = {
    more: ['Load more products', 'تحميل المزيد من المنتجات'],
    loading: ['Loading products…', 'جارٍ تحميل المنتجات…'],
    retry: ['Could not load. Tap to retry', 'تعذر التحميل. اضغط للمحاولة مجدداً'],
    end: ['All products in this category are shown', 'تم عرض جميع منتجات هذه الفئة'],
    empty: ['No products match this selection', 'لا توجد منتجات تطابق هذا الاختيار'],
    related: ['Continue discovering related products', 'تابع اكتشاف منتجات ذات صلة'],
    browse: ['Browse related categories', 'تصفح الفئات ذات الصلة'],
    filtered: ['Your filtered results end here. These category links start a separate search.', 'انتهت النتائج المطابقة للفلاتر. روابط الفئات التالية تبدأ بحثاً منفصلاً.'],
    finished: ['No more eligible products. Explore another category below.', 'لا توجد منتجات مؤهلة أخرى. استكشف فئة أخرى أدناه.'],
    scan: ['No new matches in this batch. Check the next batch', 'لا توجد نتائج جديدة في هذه الدفعة. تحقق من الدفعة التالية'],
    all: ['Browse categories', 'تصفح الفئات'],
    failedFilter: ['Update failed. Previous products are still shown. Tap to retry.', 'تعذر التحديث. لا تزال المنتجات السابقة معروضة. اضغط للمحاولة مجدداً.']
  };
  const text = key => words[key][ar ? 1 : 0];
  const pageURL = value => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || (!/\/collections\//.test(url.pathname) && !/\/search$/.test(url.pathname))) throw new Error('Invalid product feed URL');
    url.hash = '';
    return url;
  };
  const idOf = card => card.getAttribute('data-ncb-product') || card.querySelector('[data-product-id]')?.getAttribute('data-product-id') || card.getAttribute('data-product-id');
  const cardsOf = grid => Array.from(grid.children).filter(card => card.matches('.product,.y01-product-card'));
  const queryKey = value => {
    const url = pageURL(value);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('view');
    url.searchParams.sort();
    return url.pathname + url.search;
  };
  const market = () => [document.documentElement.lang, window.Shopify?.country || '', window.Shopify?.currency?.active || ''].join('|');
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    element.className = className;
    if (value) element.textContent = value;
    return element;
  };
  const visible = element => element.isConnected && element.getClientRects().length > 0 && !element.closest('[aria-hidden="true"]');
  const sourcesOf = element => {
    try { return JSON.parse(element?.dataset.ncbSources || '[]').filter(s => typeof s.url === 'string' && typeof s.title === 'string'); }
    catch (_) { return []; }
  };
  function mount(options) {
    if (controllers.has(options.element)) return controllers.get(options.element);
    const {element, grid, horizontal = false, kind = 'feed'} = options;
    const ids = options.ids || new Set();
    cardsOf(grid).forEach(card => { const id = idOf(card); if (id) ids.add(id); });
    const status = node('div', 'ncb-status');
    status.setAttribute('aria-live', 'polite');
    const button = node('button', 'ncb-more', text('more'));
    button.type = 'button';
    button.hidden = true;
    const message = node('span', 'ncb-message');
    status.append(message, button);
    element.append(status);
    grid.dataset.ncbManaged = '';
    if (horizontal) {
      grid.classList.add('ncb-rail');
      grid.tabIndex = 0;
      grid.setAttribute('role', 'region');
      grid.setAttribute('aria-label', options.title || text('related'));
    } else grid.classList.add('ncb-list');
    let next = options.next || '';
    let busy = null;
    let request = null;
    let generation = 0;
    let failed = false;
    let pendingRestore = null;
    let restoringPages = false;
    let paused = false;
    let destroyed = false;
    let blankBatches = 0;
    let sources = options.sources || [];
    let total = Number(options.total) || 0;
    let relatedController = null;
    let relatedElement = null;
    const pages = [];
    const visited = new Set();
    const timing = [];
    let frame = 0;
    let observer;
    const scrollRoot = options.scrollRoot || null;
    const current = () => !destroyed && (mobile.matches || kind === 'collection') && visible(element) && (!options.active || options.active());
    const dataset = () => {
      element.dataset.ncbNext = next;
      element.dataset.ncbPages = String(pages.length);
      element.dataset.ncbCount = String(cardsOf(grid).length);
      element.dataset.ncbTotal = String(total);
      element.dataset.y09NextPage = next ? pageURL(next).searchParams.get('page') || '1' : '';
      element.dataset.y09Loading = String(Boolean(busy));
    };
    const setStatus = key => {
      message.textContent = text(key);
      button.hidden = key !== 'retry';
      button.textContent = text(key);
      button.disabled = key === 'loading' || key === 'end' || key === 'empty' || key === 'finished';
      status.classList.toggle('is-loading', key === 'loading');
      status.dataset.ncbState = key;
      grid.setAttribute('aria-busy', String(key === 'loading'));
      dataset();
    };
    function nearEnd() {
      if (!current() || paused || failed || busy || restoringPages || !next) return false;
      const bounds = grid.getBoundingClientRect();
      const parent = scrollRoot?.getBoundingClientRect() || {top: 0, bottom: innerHeight};
      // Vertical fast scrolling may pass the sentinel between animation frames.
      // Keep catching up in serial batches; only horizontal rails need to be on screen.
      if (bounds.top > parent.bottom + 500 || ((horizontal || !mobile.matches) && bounds.bottom < parent.top)) return false;
      if (horizontal) return grid.scrollWidth - grid.clientWidth - Math.abs(grid.scrollLeft) < grid.clientWidth * 0.8;
      return status.getBoundingClientRect().top < parent.bottom + 500;
    }
    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; if (nearEnd()) load(); });
    }
    function onBrowseInput(event) {
      if (event.type === 'keydown' && !['ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageDown', 'End', ' '].includes(event.key)) return;
      if (paused) { paused = false; blankBatches = 0; }
      schedule();
    }
    const inputRoot = horizontal ? grid : element;
    const inputEvents = ['touchmove', 'wheel', 'keydown'];
    function related() {
      if (!options.related || relatedElement || destroyed) return;
      relatedElement = node('section', 'ncb-related');
      relatedElement.append(node('h2', '', text('related')));
      const links = node('nav', 'ncb-category-links');
      links.setAttribute('aria-label', text('browse'));
      const unique = new Set();
      sources.forEach(source => {
        try {
          const url = pageURL(source.url);
          if (unique.has(url.pathname) || url.pathname === pageURL(options.url).pathname) return;
          unique.add(url.pathname);
          const link = node('a', '', source.title);
          link.href = url.href;
          links.append(link);
        } catch (_) {}
      });
      const all = node('a', '', text('all'));
      all.href = (window.Shopify?.routes?.root || '/') + 'collections';
      links.append(all);
      const hasFilters = Array.from(pageURL(options.url).searchParams.keys()).some(key => key.startsWith('filter.'));
      if (hasFilters) relatedElement.append(node('p', '', text('filtered')));
      const eligibleSources = sources.filter(source => Number(source.count) > 0 && pageURL(source.url).pathname !== pageURL(options.url).pathname);
      if (!hasFilters && eligibleSources.length) {
        const rail = node('div', 'y01-product-rail ncb-rail');
        relatedElement.append(rail);
        element.append(relatedElement);
        let sourceIndex = 0;
        const first = pageURL(eligibleSources[0].url);
        first.searchParams.set('view', 'y09-category-feed');
        first.searchParams.set('page', '1');
        relatedController = mount({element: relatedElement, grid: rail, url: first.href, next: first.href, horizontal: true, ids, recommendation: true, scrollRoot, active: options.active, title: text('related'), nextSource: () => {
          sourceIndex += 1;
          if (sourceIndex >= eligibleSources.length) return '';
          const url = pageURL(eligibleSources[sourceIndex].url);
          url.searchParams.set('view', 'y09-category-feed');
          url.searchParams.set('page', '1');
          return url.href;
        }});
      } else {
        relatedElement.append(node('p', '', text('finished')));
        element.append(relatedElement);
      }
      relatedElement.append(links);
    }
    async function performLoad(token) {
      const requested = next;
      const url = pageURL(requested);
      if (kind === 'collection') url.searchParams.set('section_id', options.section);
      request = new AbortController();
      const ownRequest = request;
      const timeout = setTimeout(() => ownRequest.abort('timeout'), 15000);
      const started = performance.now();
      setStatus('loading');
      try {
        const response = await fetch(url.href, {credentials: 'same-origin', signal: request.signal, headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        if (token !== generation || destroyed || !grid.isConnected) return;
        if (kind === 'collection' && queryKey(location.href) !== queryKey(options.url)) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const result = doc.querySelector(kind === 'collection' ? '#main-collection-product-grid' : '[data-y09-feed-page]');
        if (!result || !result.hasAttribute('data-ncb-page')) throw new Error('Invalid product page');
        const expectedPage = Number(url.searchParams.get('page') || 1);
        if (Number(result.dataset.ncbPage) !== expectedPage) throw new Error('Unexpected product page');
        const incoming = Array.from(result.querySelectorAll(kind === 'collection' ? ':scope > .product' : '.y01-product-card'));
        let following = result.dataset.ncbNext || '';
        if (following) {
          const nextURL = pageURL(following);
          if (queryKey(nextURL.href) !== queryKey(url.href) || Number(nextURL.searchParams.get('page')) <= expectedPage) throw new Error('Invalid next page');
          if (kind !== 'collection') nextURL.searchParams.set('view', url.searchParams.get('view'));
          following = nextURL.href;
        }
        if (visited.has(url.href)) throw new Error('Repeated page');
        if (incoming.some(card => !idOf(card))) throw new Error('Missing product identity');
        cardsOf(grid).forEach(card => ids.add(idOf(card)));
        const fragment = document.createDocumentFragment();
        let added = 0;
        for (const card of incoming) {
          const id = idOf(card);
          if (!id) throw new Error('Missing product identity');
          if (ids.has(id) || (options.recommendation && card.dataset.ncbEligible !== 'true')) continue;
          ids.add(id);
          card.dataset.ncbBatch = String(pages.length + 1);
          fragment.append(card);
          added += 1;
        }
        // Appending above a visible footer must not let browser scroll anchoring
        // drag the shopper down and accidentally fetch the entire category.
        const scrollTopBeforeAppend = scrollRoot ? scrollRoot.scrollTop : window.scrollY;
        grid.append(fragment);
        if (!horizontal && mobile.matches) {
          grid.getBoundingClientRect(); // Flush layout/anchor adjustment before restoring.
          if (scrollRoot) scrollRoot.scrollTop = scrollTopBeforeAppend;
          else window.scrollTo({top: scrollTopBeforeAppend, behavior: 'instant'});
        }
        pages.push(url.href);
        visited.add(url.href);
        total = Number(result.dataset.ncbTotal) || 0;
        if (!sources.length) sources = sourcesOf(result);
        next = following || options.nextSource?.() || '';
        timing.push({page: expectedPage, added, ms: Math.round(performance.now() - started)});
        if (timing.length > 12) timing.shift();
        element.dataset.ncbTiming = JSON.stringify(timing);
        blankBatches = added ? 0 : blankBatches + 1;
        paused = blankBatches >= 3 && Boolean(next);
        failed = false;
        const count = cardsOf(grid).length;
        setStatus(next ? (paused ? 'scan' : 'more') : options.recommendation ? 'finished' : count ? 'end' : 'empty');
        if (!next) related();
        document.dispatchEvent(new CustomEvent('nimall:products-appended', {detail: {grid}}));
      } catch (error) {
        if (token !== generation || destroyed) return;
        failed = true;
        setStatus('retry');
      } finally {
        clearTimeout(timeout);
        if (token === generation) {
          busy = null;
          request = null;
          dataset();
          schedule();
        }
      }
    }
    function load(force = false) {
      if (busy) return busy;
      if (!next || !current() || (!force && (paused || failed))) return Promise.resolve();
      paused = false;
      failed = false;
      const token = generation;
      busy = Promise.resolve().then(() => performLoad(token));
      dataset();
      return busy;
    }
    const abort = () => {
      generation += 1;
      pendingRestore = null;
      request?.abort();
      request = null;
      busy = null;
      if (next) setStatus(failed && mobile.matches ? 'retry' : 'more');
      relatedController?.abort();
    };
    const destroy = () => {
      destroyed = true;
      abort();
      observer?.disconnect();
      cancelAnimationFrame(frame);
      (scrollRoot || window).removeEventListener('scroll', schedule);
      grid.removeEventListener('scroll', schedule);
      inputEvents.forEach(type => inputRoot.removeEventListener(type, onBrowseInput));
      window.removeEventListener('resize', schedule);
      relatedController?.destroy();
      relatedElement?.remove();
      status.remove();
      controllers.delete(element);
    };
    const snapshot = (preferredAnchor = null) => {
      const top = scrollRoot?.getBoundingClientRect().top || 0;
      const anchor = preferredAnchor && grid.contains(preferredAnchor) ? preferredAnchor : cardsOf(grid).find(card => card.getBoundingClientRect().bottom > top);
      return {key: queryKey(options.url), market: market(), pages: pages.slice(), left: grid.scrollLeft, anchor: anchor ? {id:idOf(anchor), offset:anchor.getBoundingClientRect().top - top} : null, related: relatedController?.snapshot()};
    };
    const align = saved => {
      const card = cardsOf(grid).find(card => idOf(card) === saved?.anchor?.id);
      if (!card || horizontal) return;
      const delta = card.getBoundingClientRect().top - (scrollRoot?.getBoundingClientRect().top || 0) - saved.anchor.offset;
      if (scrollRoot) scrollRoot.scrollTop += delta;
      else window.scrollBy({top:delta, behavior:'instant'});
    };
    const restore = async (saved, cancelled = () => false) => {
      if (!saved || saved.key !== queryKey(options.url) || saved.market !== market()) return false;
      pendingRestore = null;
      restoringPages = true;
      const wanted = Array.isArray(saved.pages) ? saved.pages.length : 0;
      try {
        while (pages.length < wanted && next && !cancelled() && current()) {
          const before = pages.length;
          await load(true);
          if (before === pages.length) break;
        }
        if (cancelled() || destroyed) return false;
        if (pages.length < wanted && next) {
          pendingRestore = saved;
          return false;
        }
        grid.scrollLeft = Number(saved.left) || 0;
        if (saved.related && relatedController) await relatedController.restore(saved.related, cancelled);
        return !cancelled();
      } finally {
        restoringPages = false;
      }
    };
    const settle = async (saved, cancelled = () => false) => {
      const rendered = cardsOf(grid).map(card => ({card, value: card.style.contentVisibility}));
      try {
        rendered.forEach(({card}) => { card.style.contentVisibility = 'visible'; });
        for (let i = 0; i < 90 && !cancelled() && current(); i += 1) {
          align(saved);
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
      } finally {
        rendered.forEach(({card, value}) => { card.style.contentVisibility = value; });
      }
      for (let i = 0; i < 12 && !cancelled() && current(); i += 1) {
        align(saved);
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
    };
    const syncViewport = () => {
      status.style.display = mobile.matches || kind === 'collection' ? '' : 'none';
      if (relatedElement) relatedElement.style.display = mobile.matches ? '' : 'none';
    };
    const api = {load, abort, destroy, snapshot, restore, align, settle, syncViewport, schedule, grid, element, get busy() {return busy;}, get next() {return next;}};
    controllers.set(element, api);
    button.addEventListener('click', async () => {
      if (!pendingRestore) { await load(true); return; }
      const saved = pendingRestore;
      let cancelled = false;
      const cancel = () => { cancelled = true; };
      const events = ['touchstart', 'pointerdown', 'wheel', 'keydown'];
      events.forEach(type => window.addEventListener(type, cancel, {passive:true}));
      try {
        if (await restore(saved, () => cancelled)) await settle(saved, () => cancelled);
      } finally {
        events.forEach(type => window.removeEventListener(type, cancel));
      }
    });
    inputEvents.forEach(type => inputRoot.addEventListener(type, onBrowseInput, {passive: true}));
    (scrollRoot || window).addEventListener('scroll', schedule, {passive: true});
    if (horizontal) grid.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(schedule, {root: scrollRoot, rootMargin: '500px 0px'});
      observer.observe(horizontal ? grid : status);
    }
    dataset();
    if (!next) { setStatus(ids.size ? 'end' : 'empty'); related(); }
    else { setStatus('more'); schedule(); }
    return api;
  }
  let main;
  let collectionSession = false;
  let queryRequest;
  let queryGeneration = 0;
  let restoring = false;
  let mainObserver;
  let navigationAnchor = null;
  function save(preferredAnchor = null) {
    if (navigationAnchor && !preferredAnchor) return;
    if (preferredAnchor && main?.grid.contains(preferredAnchor)) navigationAnchor = preferredAnchor;
    if (!mobile.matches && !collectionSession) return;
    try {
      const previous = history.state;
      if (previous !== null && (typeof previous !== 'object' || Array.isArray(previous))) return;
      // This entry owns an asynchronous, multi-page restore. Native history
      // scrolling can otherwise run after our anchor and move it a second time.
      if (main && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
      const rails = [];
      controllers.forEach(c => {
        if (c !== main && !c.element.closest('.ncb-related') && c.grid.classList.contains('ncb-rail') && visible(c.element)) rails.push(c.snapshot());
      });
      history.replaceState({...previous, nimallBrowse: {market: market(), path: location.pathname + location.search, top: scrollY, main: main?.snapshot(navigationAnchor), rails}}, '');
    } catch (_) {}
  }
  function mountMain() {
    if ((!mobile.matches && !collectionSession) || !document.body.classList.contains('template-collection')) return;
    const grid = document.querySelector('#main-collection-product-grid[data-ncb-page]');
    if (!grid || !visible(grid) || main?.grid === grid) return;
    main?.destroy();
    const element = grid.closest('.collection');
    if (!element) return;
    collectionSession = true;
    document.querySelector('#CollectionProductGrid')?.setAttribute('data-ncb-collection-session', '');
    element.querySelectorAll('.pagination').forEach(pagination => {pagination.dataset.ncbNativeAuto = String(pagination.classList.contains('pagination-infinite')); pagination.classList.remove('pagination-infinite'); pagination.hidden = true;});
    element.querySelectorAll('[data-infinite-scrolling]').forEach(button => {button.dataset.ncbNativeInfinite = ''; button.removeAttribute('data-infinite-scrolling');});
    document.querySelectorAll('.nimall-category-discovery[data-category-discovery]').forEach(discovery => {
      if (!discovery.closest('[data-y01-root]')) discovery.classList.add('ncb-replaced-discovery');
    });
    main = mount({element, grid, url: location.href, next: grid.dataset.ncbNext, sources: sourcesOf(grid), total: grid.dataset.ncbTotal, kind: 'collection', section: grid.dataset.id, related: true, active: () => !queryRequest});
  }
  async function restoreMain(saved = history.state?.nimallBrowse) {
    if (!saved || saved.market !== market() || saved.path !== location.pathname + location.search) return;
    if (main && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    restoring = true;
    if (main && saved.main && !await main.restore(saved.main, () => !restoring)) {
      restoring = false;
      return;
    }
    for (const c of controllers.values()) {
      if (!restoring) break;
      const record = saved.rails?.find(r => r.key === c.snapshot().key);
      if (record) await c.restore(record, () => !restoring);
    }
    if (restoring) {
      window.scrollTo({top: Math.max(0, saved.top || 0), behavior: 'instant'});
      await new Promise(resolve => requestAnimationFrame(resolve));
      if (restoring && saved.main) await main?.settle(saved.main, () => !restoring);
    }
    restoring = false;
  }
  async function filter(searchParams, event, updateURL, Form) {
    if (updateURL) save();
    restoring = false;
    queryRequest?.abort();
    main?.abort();
    const token = ++queryGeneration;
    queryRequest = new AbortController();
    const saved = !updateURL ? history.state?.nimallBrowse : null;
    const params = new URLSearchParams(searchParams);
    params.delete('page');
    const grid = document.querySelector('#main-collection-product-grid');
    const container = document.querySelector('#CollectionProductGrid');
    if (!grid || !container) return;
    const notice = container.querySelector('.ncb-query-status') || node('button', 'ncb-query-status', text('loading'));
    notice.type = 'button';
    notice.textContent = text('loading');
    notice.disabled = true;
    container.append(notice);
    grid.setAttribute('aria-busy', 'true');
    const requested = new URL(location.pathname, location.origin);
    requested.search = params.toString();
    requested.searchParams.set('section_id', grid.dataset.id);
    const ownQueryRequest = queryRequest;
    const timeout = setTimeout(() => ownQueryRequest.abort('timeout'), 15000);
    try {
      const response = await fetch(requested.href, {credentials:'same-origin', signal: queryRequest.signal});
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const html = await response.text();
      if (token !== queryGeneration) return;
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const newGrid = parsed.querySelector('#main-collection-product-grid[data-ncb-page]');
      if (!newGrid) throw new Error('Missing grid');
      main?.destroy();
      main = null;
      Form.searchParamsPrev = params.toString();
      if (updateURL) Form.updateURLHash(params.toString());
      Form.renderFilters(html, event);
      container.querySelector('.collection')?.replaceWith(newGrid.closest('.collection'));
      Form.renderProductGrid(html);
      mountMain();
      notice.remove();
      queryRequest = null;
      if (saved) await restoreMain(saved);
    } catch (error) {
      if (token !== queryGeneration) return;
      notice.textContent = text('failedFilter');
      notice.disabled = false;
      notice.onclick = () => filter(searchParams, event, updateURL, Form);
      grid.setAttribute('aria-busy', 'false');
      document.body.classList.remove('has-halo-loader');
    } finally {
      clearTimeout(timeout);
      if (token === queryGeneration) {queryRequest = null; main?.schedule();}
    }
  }
  function start() {
    const saved = history.state?.nimallBrowse;
    if (saved?.main && saved.market === market() && saved.path === location.pathname + location.search) collectionSession = true;
    mountMain();
    const container = document.querySelector('#CollectionProductGrid');
    if (container) {
      mainObserver = new MutationObserver(() => {
        if (main && !main.grid.isConnected) {main.destroy(); main = null;}
        mountMain();
      });
      mainObserver.observe(container, {childList:true, subtree:true});
    }
    if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') requestAnimationFrame(() => restoreMain());
  }
  window.NimallContinuous = {mount, get: element => controllers.get(element), filter, save, restoreMain, ownsCollection: () => collectionSession};
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="/products/"]');
    if (link) save(link.closest('.product,.y01-product-card'));
  }, true);
  ['pointerdown','touchstart','wheel','keydown'].forEach(type => document.addEventListener(type, () => {restoring = false; navigationAnchor = null;}, {passive:true}));
  window.addEventListener('pagehide', () => {save(); controllers.forEach(c => c.abort());});
  window.addEventListener('pageshow', event => {
    if (event.persisted) restoreMain().finally(() => controllers.forEach(c => c.schedule()));
  });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) {
      if (!collectionSession && 'scrollRestoration' in history) history.scrollRestoration = 'auto';
      controllers.forEach(c => {if (c !== main) c.abort(); c.syncViewport(); c.schedule();});
      if (!collectionSession) {
        document.querySelectorAll('#CollectionProductGrid .pagination').forEach(p => {p.hidden = false; p.classList.toggle('pagination-infinite', p.dataset.ncbNativeAuto === 'true');});
        document.querySelectorAll('#CollectionProductGrid [data-ncb-native-infinite]').forEach(b => b.setAttribute('data-infinite-scrolling',''));
      }
      document.querySelectorAll('.ncb-replaced-discovery').forEach(d => d.classList.remove('ncb-replaced-discovery'));
    } else {
      document.querySelectorAll('#CollectionProductGrid .pagination').forEach(p => {p.hidden = true; p.classList.remove('pagination-infinite');});
      document.querySelectorAll('#CollectionProductGrid [data-ncb-native-infinite]').forEach(b => b.removeAttribute('data-infinite-scrolling'));
      document.querySelectorAll('.nimall-category-discovery[data-category-discovery]').forEach(d => {if (!d.closest('[data-y01-root]')) d.classList.add('ncb-replaced-discovery');});
      mountMain(); controllers.forEach(c => {c.syncViewport(); c.schedule();});
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

(() => {
  const viewport = window.matchMedia('(max-width: 767px)');
  let restore = null;
  function syncProductLayout() {
    if (!viewport.matches) {
      if (restore) restore();
      restore = null;
      return;
    }
    if (restore || !document.body.classList.contains('template-product')) return;
    const product = document.querySelector('.productView-product');
    const form = product?.querySelector('.productView-form');
    if (!form) return;
    const controls = [...form.querySelectorAll('.productView-wishlist, .productView-share')];
    const badge = product.querySelector('.jdgm-preview-badge');
    const review = badge?.closest('.shopify-app-block') || badge;
    const anchor = review || product.querySelector('.productView-price')?.closest('.productView-moreItem');
    if (!anchor) return;
    const row = document.createElement('div');
    row.className = 'y15-pdp-review-row';
    const actions = document.createElement('div');
    actions.className = 'y15-pdp-secondary-actions';
    const moved = [];
    const cleanups = [];
    function move(node, destination) {
      const marker = document.createTextNode('');
      node.before(marker);
      moved.push({ node, marker });
      destination.appendChild(node);
    }
    anchor.after(row);
    if (review) move(review, row);
    row.appendChild(actions);
    controls.forEach(control => {
      const trigger = control.querySelector('.share-button__button');
      if (trigger) {
        trigger.type = 'button';
        trigger.setAttribute('aria-label', trigger.textContent.trim());
      }
      const wishlist = control.querySelector('[data-wishlist]');
      if (wishlist) {
        wishlist.setAttribute('role', 'button');
        const toggle = event => {
          if (!viewport.matches) return;
          const handle = wishlist.dataset.wishlistHandle;
          try {
            const stored = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
            const items = Array.isArray(stored) ? stored : [];
            const adding = !items.includes(handle);
            const next = adding ? [...items, handle] : items.filter(item => item !== handle);
            localStorage.setItem('wishlistItem', JSON.stringify(next));
            event.preventDefault();
            event.stopPropagation();
            document.querySelectorAll('[data-wishlist-handle]').forEach(item => {
              if (item.dataset.wishlistHandle !== handle) return;
              item.classList.toggle('wishlist-added', adding);
              item.setAttribute('aria-pressed', String(adding));
            });
            document.querySelectorAll('[data-wishlist-count]').forEach(item => { item.textContent = next.length; });
            document.dispatchEvent(new CustomEvent('updatewishlistmail', { bubbles: true }));
          } catch (error) {
            void error;
          }
        };
        const keydown = event => { if (event.key === ' ') toggle(event); };
        wishlist.addEventListener('click', toggle);
        wishlist.addEventListener('keydown', keydown);
        cleanups.push(() => {
          wishlist.removeEventListener('click', toggle);
          wishlist.removeEventListener('keydown', keydown);
          wishlist.removeAttribute('role');
          wishlist.removeAttribute('aria-pressed');
        });
      }
      move(control, actions);
    });
    product.classList.add('y15-pdp-ready');
    restore = () => {
      cleanups.forEach(cleanup => cleanup());
      moved.forEach(({ node, marker }) => marker.replaceWith(node));
      row.remove();
      product.classList.remove('y15-pdp-ready');
    };
  }
  document.addEventListener('DOMContentLoaded', syncProductLayout);
  document.addEventListener('shopify:section:load', () => {
    if (restore) restore();
    restore = null;
    syncProductLayout();
  });
  viewport.addEventListener('change', syncProductLayout);
  if (document.readyState !== 'loading') syncProductLayout();
})();

(() => {
  const ar = document.documentElement.lang.startsWith('ar');
  const ui = {"Home":"الرئيسية","Categories":"الفئات","All Categories":"جميع الفئات","Deals":"العروض","You":"حسابي","Cart":"السلة","Account":"الحساب","Gift Cards":"بطاقات الهدايا","Wish Lists":"المفضلة","Wish list":"المفضلة","View all":"عرض الكل","View All":"عرض الكل","New Arrival":"وصل حديثاً","New arrivals":"وصل حديثاً","New Arrivals":"وصل حديثاً","New on Nimall":"الجديد لدى Nimall","Coupon":"الكوبونات","Brand":"العلامات التجارية","Personal Care":"العناية الشخصية","Affiliate":"التسويق بالعمولة","Sell On Nimall":"بع على Nimall","Sell on Nimall":"بع على Nimall","Support":"الدعم","Nimall Certification":"فحص Nimall","1–3 Days":"١–٣ أيام","1–3 Days Local Delivery":"توصيل محلي خلال ١–٣ أيام","What are you looking for?":"عمّ تبحث؟","Search Nimall":"ابحث في Nimall","Search":"بحث","Search deals or products":"ابحث عن عروض أو منتجات","Deliver to":"التوصيل إلى","Add delivery address":"أضف عنوان التوصيل","Manage delivery address":"إدارة عنوان التوصيل","Nimall mobile shopping":"تسوّق Nimall على الهاتف","Fresh picks and member offers":"منتجات جديدة وعروض للأعضاء","Open":"افتح","BACK TO SCHOOL":"العودة إلى المدرسة","Study-ready finds":"مستلزمات جاهزة للدراسة","Smart picks for class, campus and home.":"اختيارات ذكية للمدرسة والجامعة والمنزل.","DAILY ESSENTIALS":"أساسيات يومية","More for every day":"المزيد لكل يوم","Useful home and tech finds in one place.":"مستلزمات المنزل والتقنية في مكان واحد.","Everyday essentials,":"أساسيات يومية،","picked for you":"اخترناها لك","Explore practical finds across home, tech and lifestyle.":"اكتشف اختيارات عملية للمنزل والتقنية والحياة اليومية.","Shop new arrivals":"تسوّق الجديد","MADE FOR YOUR DAY":"اختيارات ليومك","Home refresh":"جدّد منزلك","Home essentials":"أساسيات المنزل","Electronics essentials":"أساسيات الإلكترونيات","Kitchen picks":"اختيارات للمطبخ","Save More":"وفّر أكثر","Save more":"وفّر أكثر","SAVE MORE":"وفّر أكثر","HOME EDIT":"اختيارات المنزل","Refresh your everyday":"جدّد حياتك اليومية","Practical picks for every room":"اختيارات عملية لكل غرفة","15%-40% Off - Limited Deals":"خصم ١٥٪–٤٠٪ على عروض مختارة","60%-65% Off - Limited Deals":"خصم ٦٠٪–٦٥٪ على عروض مختارة","Up to 50% Off":"خصم يصل إلى ٥٠٪","NEW THIS WEEK":"الجديد هذا الأسبوع","Fresh finds, ready now":"اختيارات جديدة متاحة الآن","Browse the latest Nimall arrivals":"تصفّح أحدث منتجات Nimall","TECH PICKS":"اختيارات تقنية","Power your day":"تقنية ليومك","Devices and accessories in one place":"أجهزة وإكسسوارات في مكان واحد","FRESH OFFERS":"عروض جديدة","Today’s deal drop":"عروض اليوم","Live prices from real Nimall products.":"الأسعار الحالية لمنتجات Nimall.","TIME LEFT TODAY":"الوقت المتبقي اليوم","HRS":"ساعة","MIN":"دقيقة","SEC":"ثانية","15%-40% off":"خصم ١٥٪–٤٠٪","15%-40% OFF":"خصم ١٥٪–٤٠٪","Tech deals":"عروض التقنية","TECH DEALS":"عروض التقنية","More value, less searching":"قيمة أكبر وبحث أقل","Limited deals across everyday categories":"عروض مختارة على احتياجاتك اليومية","Everyday value, curated":"قيمة يومية اخترناها لك","Browse the latest price-led picks":"تصفّح أحدث العروض","Smart upgrades for less":"تحديثات ذكية بسعر أقل","Electronics and accessories":"إلكترونيات وإكسسوارات","READY WHEN YOU ARE":"جاهزون عندما تكون مستعداً","Your bag":"سلة مشترياتك","Review your items before delivery and payment":"راجع منتجاتك قبل التوصيل والدفع","Your shopping cart is empty":"سلة مشترياتك فارغة","What are you waiting for?":"اكتشف ما يناسبك","Start Shopping":"ابدأ التسوق","Discover new arrivals and everyday offers":"اكتشف المنتجات الجديدة والعروض اليومية","YOUR ORDER":"طلبك","item":"منتج","items":"منتجات","Continue shopping":"متابعة التسوق","CHECKOUT SUBTOTAL":"المجموع الفرعي","Update":"تحديث","Continue to checkout":"متابعة إلى الدفع","Bestsellers for you":"الأكثر مبيعاً لك","Just for you":"من أجلك","Home &amp;":"المنزل و","Home &amp; Kitchen":"المنزل والمطبخ","Home & Kitchen":"المنزل والمطبخ","Kitchen":"المطبخ","Men's Fashion":"أزياء الرجال","Women's Fashion":"أزياء النساء","Mobiles &amp;":"الهواتف و","Accessories":"الإكسسوارات","Mobiles &amp; Accessories":"الهواتف والإكسسوارات","Appliances":"الأجهزة المنزلية","Beauty &amp;":"الجمال و","Beauty &amp; Personal Care":"الجمال والعناية الشخصية","Laptops &amp;":"الحواسيب المحمولة و","Laptops &amp; Accessories":"الحواسيب المحمولة والإكسسوارات","Laptops & Desktops":"الحواسيب المحمولة والمكتبية","Electronics":"الإلكترونيات","Baby":"الأطفال","Toys":"الألعاب","Sports &amp;":"الرياضة و","Sports &amp; Outdoors":"الرياضة والأنشطة الخارجية","Outdoors":"الأنشطة الخارجية","Health &amp;":"الصحة و","Health &amp; Nutrition":"الصحة والتغذية","Nutrition":"التغذية","Watches &amp;":"الساعات و","Watches &amp; Jewelry":"الساعات والمجوهرات","Watches & Jewelry":"الساعات والمجوهرات","Jewelry":"المجوهرات","Office &amp;":"المكتب و","Office &amp; Education":"المكتب والتعليم","Education":"التعليم","Pet Supplies":"مستلزمات الحيوانات الأليفة","Automotive":"مستلزمات السيارات","More":"المزيد","Nimall Top Picks":"اختيارات Nimall المميزة","KSA Picks":"اختيارات السعودية","Laptops":"الحواسيب المحمولة","Beauty":"الجمال","Mother & Baby":"الأم والطفل","Sports":"الرياضة","Furniture":"الأثاث","Bedding":"المفروشات","Storage":"التخزين","Bath":"الحمّام","Cleaning":"التنظيف","Fashion":"الأزياء","Shoes":"الأحذية","Power Banks":"بطاريات متنقلة","Toys & Games":"ألعاب وترفيه","Camping":"التخييم","Stationery":"القرطاسية","Tools":"الأدوات","Men's Care":"العناية بالرجال","Sportswear":"ملابس رياضية","Grooming":"العناية بالمظهر","Backpacks":"حقائب الظهر","Women's Care":"العناية بالنساء","Women's Bags":"حقائب نسائية","Lingerie & Lounge":"ملابس داخلية ومنزلية","Mobile Accessories":"إكسسوارات الهواتف","Video Games":"ألعاب الفيديو","Kitchen Appliances":"أجهزة المطبخ","Fans":"المراوح","Coffee":"القهوة","Home Appliances":"الأجهزة المنزلية","All orders":"جميع الطلبات","Order status":"حالة الطلب","Shipping":"الشحن","Returns":"الإرجاع","Profile":"الملف الشخصي","Address":"العنوان","Saved items":"المنتجات المحفوظة","Returns &amp; refunds":"الإرجاع والاسترداد","Help &amp; support":"المساعدة والدعم","Your account":"حسابك","Your orders":"طلباتك","Your details":"بياناتك","More from Nimall":"المزيد من Nimall","Shop By Category":"تسوّق حسب الفئة","Frequently Bought Together":"منتجات تُشترى معاً","Customers Also Viewed":"شاهد العملاء أيضاً","HAVE QUESTIONS?":"هل لديك أسئلة؟","Customer Support":"دعم العملاء","WhatsApp Support":"الدعم عبر واتساب","Loading products":"جارٍ تحميل المنتجات","Load more products":"تحميل المزيد من المنتجات","All products loaded":"تم تحميل جميع المنتجات","No products available":"لا توجد منتجات متاحة","Retry loading products":"إعادة محاولة تحميل المنتجات","Load products":"تحميل المنتجات"};
  const tr = text => ar ? (ui[text] || text) : text;
  const mobile = window.matchMedia('(max-width: 767px)');

  function initY01() {
    if (!mobile.matches) {
      document.body.classList.remove('y01-mobile-ready', 'y01-panel-open');
      document.querySelectorAll('[data-y01-panel].is-open').forEach(panel => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      return;
    }
    const root = document.querySelector('[data-y01-root]');
    if (!root) return;
    document.body.classList.add('y01-mobile-ready');
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const style = document.createElement('style');
    style.id = 'nimall-y11-mobile-style';
    style.textContent = `
      .y08-account-kicker{display:none}
      .y08-account-grid a{min-height:54px;grid-template-columns:34px minmax(0,1fr) auto;gap:6px}
      .y08-service-icon{width:34px;height:34px;border-radius:10px;font-size:0}
      .y08-service-icon svg{width:21px;height:21px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
      .y08-account-grid strong{font-size:11px;font-weight:850;line-height:1.18}
      .y08-account-section h2{font-size:17px;font-weight:900}
      .y09-feed-sentinel{min-height:52px;padding:10px 0 2px;display:grid;place-items:center;grid-column:1/-1}
      .y09-feed-sentinel button{min-height:38px;padding:8px 18px;border:1px solid #e5ddd2;border-radius:20px;background:#fff;color:#242733;font-size:10px;font-weight:850;box-shadow:0 2px 6px rgba(54,41,30,.06)}
      .y09-feed-sentinel button[disabled]{border-color:transparent;background:transparent;color:#77736e;box-shadow:none}
      .y09-feed-sentinel.is-loading button{color:#006c35}
      .y09-feed-sentinel.is-loading button::after{content:'';width:12px;height:12px;margin-left:7px;display:inline-block;vertical-align:-2px;border:2px solid #b9d7c8;border-top-color:#006c35;border-radius:50%;animation:y09-spin .7s linear infinite}
      @keyframes y09-spin{to{transform:rotate(360deg)}}
    `;
    if (!document.getElementById(style.id)) document.head.appendChild(style);

    const appPromo = root.querySelector('[data-y03-app-promo]');
    try {
      if (window.sessionStorage.getItem('nimall-y03-app-promo-dismissed') === 'true' && appPromo) appPromo.hidden = true;
    } catch (error) {
      void error;
    }

    const homeHeaderMain = root.querySelector('.y01-header__main');
    if ((document.body.classList.contains('template-index') || document.body.classList.contains('template-product')) && homeHeaderMain) {
      const stickyHomeSearch = homeHeaderMain.cloneNode(true);
      stickyHomeSearch.classList.add('y11-sticky-search');
      stickyHomeSearch.setAttribute('aria-hidden', 'true');
      root.appendChild(stickyHomeSearch);
      let stickyFrame = 0;
      let stickyVisible = false;
      const syncStickyHomeSearch = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(() => {
          const visible = homeHeaderMain.getBoundingClientRect().bottom <= 0;
          if (visible === stickyVisible) { stickyFrame = 0; return; }
          stickyVisible = visible;
          stickyHomeSearch.classList.toggle('is-visible', visible);
          stickyHomeSearch.setAttribute('aria-hidden', visible ? 'false' : 'true');
          stickyFrame = 0;
        });
      };
      window.addEventListener('scroll', syncStickyHomeSearch, { passive: true });
      syncStickyHomeSearch();
    }

    const panels = [...root.querySelectorAll('[data-y01-panel]')];
    const navButtons = [...root.querySelectorAll('[data-y01-open]')];
    let quantityTimer = 0;

    const accountIcons = {
      'all orders': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 7 8-4 8 4-8 4-8-4Z"/><path d="M4 7v10l8 4 8-4V7M12 11v10"/></svg>',
      'order status': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12v18H6zM9 7h6M9 11h6M9 15h4"/></svg>',
      'shipping': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
      'returns': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 7-4 4 4 4"/><path d="M4 11h10a6 6 0 1 1 0 12M16 17l4-4-4-4"/><path d="M20 13H10a6 6 0 0 1-6-6"/></svg>',
      'profile': '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4.5 21a7.5 7.5 0 0 1 15 0"/></svg>',
      'address': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>',
      'saved items': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>',
      'returns & refunds': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 7-4 4 4 4"/><path d="M3 11h11a7 7 0 1 1-7 7"/><path d="M8 18H4v4"/></svg>',
      'help & support': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.5 8.5 0 0 1-10.4 8.3L4 22l1.8-5A8.5 8.5 0 1 1 21 11.5Z"/><path d="M9.8 9a2.3 2.3 0 1 1 3.8 1.8c-.9.7-1.6 1.1-1.6 2.2M12 16h.01"/></svg>',
      'sell on nimall': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10v10h16V10M3 10l2-6h14l2 6"/><path d="M3 10a3 3 0 0 0 5 2 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 5-2M9 20v-5h6v5"/></svg>'
    };

    root.querySelectorAll('.y08-account-grid a').forEach((link) => {
      const label = (link.querySelector('strong')?.dataset.y32Label || link.querySelector('strong')?.textContent)?.trim().toLowerCase();
      const icon = link.querySelector('.y08-service-icon');
      if (label && icon && accountIcons[label]) {
        icon.innerHTML = accountIcons[label];
        icon.setAttribute('aria-hidden', 'true');
      }
    });

    const countdown = root.querySelector('[data-y10-countdown]');
    if (countdown) {
      const hours = countdown.querySelector('[data-y10-hours]');
      const minutes = countdown.querySelector('[data-y10-minutes]');
      const seconds = countdown.querySelector('[data-y10-seconds]');
      const progress = root.querySelector('[data-y11-deals-progress]');
      const updateCountdown = () => {
        const now = new Date();
        const startOfDay = new Date(now);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(now);
        endOfDay.setHours(24, 0, 0, 0);
        const remaining = Math.max(0, endOfDay.getTime() - now.getTime());
        const remainingHours = Math.floor(remaining / 3600000);
        const remainingMinutes = Math.floor((remaining % 3600000) / 60000);
        const remainingSeconds = Math.floor((remaining % 60000) / 1000);
        if (hours) hours.firstChild.textContent = String(remainingHours).padStart(2, '0');
        if (minutes) minutes.firstChild.textContent = String(remainingMinutes).padStart(2, '0');
        if (seconds) seconds.firstChild.textContent = String(remainingSeconds).padStart(2, '0');
        if (progress) {
          const duration = endOfDay.getTime() - startOfDay.getTime();
          const elapsed = Math.max(0, now.getTime() - startOfDay.getTime());
          const percentage = Math.min(100, Math.round((elapsed / duration) * 100));
          progress.style.setProperty('--y11-progress', `${percentage}%`);
          progress.setAttribute('aria-valuenow', String(percentage));
        }
      };
      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    }

    const carouselCanAdvance = (carousel) => {
      const rect = carousel.getBoundingClientRect();
      return document.visibilityState === 'visible' &&
        window.innerWidth <= 1024 && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight &&
        !document.body.classList.contains('y01-panel-open') &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        Date.now() >= Number(carousel.dataset.autoplayResumeAt || 0) &&
        !(window.matchMedia('(hover: hover)').matches && carousel.matches(':hover'));
    };
    const pauseCarouselOnInput = (carousel) => {
      const pause = () => { carousel.dataset.autoplayResumeAt = String(Date.now() + 8000); };
      carousel.addEventListener('pointerdown', pause, { passive: true });
      carousel.addEventListener('touchstart', pause, { passive: true });
      carousel.addEventListener('touchmove', pause, { passive: true });
      carousel.addEventListener('keydown', pause);
    };

    const mountSnapCarousel = (carousel, track, items, dots, interval) => {
      if (!track || items.length < 2) return;
      let current = 0;
      let scrollFrame = 0;
      let positions;
      const invalidatePositions = () => { positions = null; };
      const readPositions = () => {
        if (positions) return positions;
        const origin = track.offsetLeft;
        positions = items.map(item => item.offsetLeft - origin);
        return positions;
      };
      const setCurrent = index => {
        if (index === current) return;
        current = index;
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
      };
      const activate = (index, smooth = true) => {
        const next = (index + items.length) % items.length;
        const left = readPositions()[next];
        track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        setCurrent(next);
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => activate(index)));
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          const left = track.scrollLeft;
          const nearest = readPositions().reduce((best, position, index) => {
            const distance = Math.abs(position - left);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Number.POSITIVE_INFINITY });
          setCurrent(nearest.index);
        });
      }, { passive: true });
      // Resize and late-loading images can change offsets. Re-measure once on
      // the next action, not once per item on every scroll animation frame.
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(invalidatePositions);
        observer.observe(track);
        items.forEach(item => observer.observe(item));
      } else {
        window.addEventListener('resize', invalidatePositions, { passive: true });
      }
      track.addEventListener('load', invalidatePositions, true);
      pauseCarouselOnInput(carousel);
      window.setInterval(() => {
        if (carouselCanAdvance(carousel)) activate(current + 1);
      }, interval);
    };

    root.querySelectorAll('[data-y02-carousel]').forEach(carousel => {
      mountSnapCarousel(carousel, carousel.querySelector('[data-y02-carousel-track]'),
        [...carousel.querySelectorAll('.y02-hero__slide')],
        [...carousel.querySelectorAll('[data-y02-slide]')], 3000);
    });

    root.querySelectorAll('[data-y03-quick-carousel]').forEach(carousel => {
      mountSnapCarousel(carousel, carousel.querySelector('[data-y03-quick-track]'),
        [...carousel.querySelectorAll('[data-y03-quick-page]')],
        [...carousel.querySelectorAll('[data-y03-quick-dot]')], 6000);
    });

    const loadFeed = feed => window.NimallContinuous.get(feed)?.load(true) || Promise.resolve();
    const setupFeed = (feed, grid, url, kind, nextPage) => {
      if (!feed || !grid || !url) return;
      const next = new URL(url, location.origin);
      next.searchParams.set('view', /\/search$/.test(next.pathname) ? 'nimall-category-feed' : kind === 'category' ? 'y09-category-feed' : 'y09-feed');
      next.searchParams.set('page', nextPage);
      feed.dataset.y09Enhanced = 'true';
      grid.dataset.y09Grid = '';
      window.NimallContinuous.mount({
        element: feed, grid, url, next: next.href, related: kind === 'category',
        horizontal: kind === 'home', title: feed.querySelector('h2')?.textContent,
        scrollRoot: kind === 'category' ? root.querySelector('.y01-category-browser__content') : null,
        active: () => kind !== 'category' || Boolean(feed.closest('.y01-category-set.is-active') && feed.closest('.y01-panel.is-open'))
      });
    };
    const categoryFeeds = [...root.querySelectorAll('[data-y09-feed]')];
    const categoryButtons = [...root.querySelectorAll('[data-y01-category]')];
    const categorySets = [...root.querySelectorAll('[data-y01-category-set]')];
    categoryFeeds.forEach(feed => {
      setupFeed(feed, feed.querySelector('.y07-category-feed__grid'), feed.dataset.y09Feed, 'category', '1');
    });
    root.querySelectorAll('.y01-home .y01-shelf, .y01-deals .y01-shelf').forEach(shelf => {
      if (shelf.hasAttribute('data-ncb-deals-rotation')) return;
      const grid = shelf.querySelector('.y01-product-rail');
      const link = shelf.querySelector('.y01-section-heading a');
      setupFeed(shelf, grid, link?.href, 'home', '2');
    });

    const loadActiveCategory = () => {
      const feed = root.querySelector('[data-y01-panel="categories"] .y01-category-set.is-active [data-y09-feed]');
      // Paint the selected category before starting feed work. Recheck state
      // after yielding so rapid switches cannot load a now-hidden category.
      if (feed && !feed.querySelector('[data-y09-grid]')?.children.length) {
        window.requestAnimationFrame(() => window.setTimeout(() => {
          if (feed.closest('.y01-category-set.is-active') && feed.closest('.y01-panel.is-open')) loadFeed(feed);
        }, 0));
      }
    };

    const categoryPanel = root.querySelector('[data-y01-panel="categories"]');
    const categoryContent = root.querySelector('.y01-category-browser__content');
    const categorySidebar = root.querySelector('.y01-category-browser__primary');
    let restoringCategory = false;
    const cancelCategoryRestore = () => { restoringCategory = false; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => {
      root.addEventListener(type, cancelCategoryRestore, { passive: true });
    });
    const selectCategory = (category, smooth = true) => {
      const button = categoryButtons
        .find(item => item.dataset.y01Category === category);
      if (!button) return false;
      categoryButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      categorySets.forEach(set => {
        set.classList.toggle('is-active', set.dataset.y01CategorySet === category);
      });
      categoryFeeds.forEach(feed => {
        if (!feed.closest('.y01-category-set.is-active')) window.NimallContinuous.get(feed)?.abort();
        else window.NimallContinuous.get(feed)?.schedule();
      });
      categoryContent?.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      return true;
    };
    const saveCategoryNavigation = () => {
      if (!mobile.matches) return;
      try {
        const previous = window.history.state;
        // Leave unknown router state shapes untouched. Never create a history
        // entry or store product HTML, prices, inventory or customer data.
        if (previous !== null && (typeof previous !== 'object' || Array.isArray(previous))) return;
        const state = { ...previous };
        const active = categoryPanel?.querySelector('.y01-category-set.is-active');
        if (categoryPanel?.classList.contains('is-open') && active) {
          const feed = active.querySelector('[data-y09-feed]');
          state.nimallWapCategory = {
            version: 2,
            feed: window.NimallContinuous.get(feed)?.snapshot(),
            category: active.dataset.y01CategorySet,
            contentTop: Math.max(0, categoryContent?.scrollTop || 0),
            sidebarTop: Math.max(0, categorySidebar?.scrollTop || 0),
          };
        } else {
          delete state.nimallWapCategory;
        }
        window.history.replaceState(state, '');
      } catch (error) {
        void error;
      }
    };
    window.addEventListener('pagehide', saveCategoryNavigation);
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (link && !event.defaultPrevented && !event.metaKey && !event.ctrlKey &&
          !event.shiftKey && !event.altKey && (!link.target || link.target === '_self')) {
        saveCategoryNavigation();
      }
    }, true);

    const closePanels = () => {
      cancelCategoryRestore();
      categoryFeeds.forEach(feed => window.NimallContinuous.get(feed)?.abort());
      panels.forEach((panel) => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      navButtons.forEach((button) => button.classList.remove('is-active'));
      document.body.classList.remove('y01-panel-open');
    };

    const openPanel = (name) => {
      const panel = root.querySelector(`[data-y01-panel="${name}"]`);
      if (!panel) return;
      closePanels();
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      navButtons.filter((button) => button.dataset.y01Open === name).forEach((button) => button.classList.add('is-active'));
      document.body.classList.add('y01-panel-open');
      panel.querySelector('button, a, input')?.focus({ preventScroll: true });
      if (name === 'categories') loadActiveCategory();
    };

    const restoreCategoryNavigation = async () => {
      if (!categoryPanel || !categoryContent || !mobile.matches) return;
      let saved;
      try {
        if (window.performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
        saved = window.history.state?.nimallWapCategory;
      } catch (error) { return; }
      if (saved?.version !== 2 || !Number.isFinite(saved.contentTop) ||
          !Number.isFinite(saved.sidebarTop) || !selectCategory(saved.category, false)) return;
      openPanel('categories');
      restoringCategory = true;
      if (categorySidebar) categorySidebar.scrollTop = Math.max(0, saved.sidebarTop);
      const feed = categoryPanel.querySelector('.y01-category-set.is-active [data-y09-feed]');
      if (feed) await window.NimallContinuous.get(feed)?.restore(saved.feed, () => !restoringCategory);
      if (restoringCategory && mobile.matches && categoryPanel.classList.contains('is-open')) {
        categoryContent.scrollTop = Math.max(0, saved.contentTop);
        await new Promise(resolve => requestAnimationFrame(resolve));
        if (restoringCategory && feed) await window.NimallContinuous.get(feed)?.settle(saved.feed, () => !restoringCategory);
      }
      restoringCategory = false;
    };

    root.addEventListener('click', (event) => {
      const promoClose = event.target.closest('[data-y03-promo-close]');
      const open = event.target.closest('[data-y01-open]');
      const close = event.target.closest('[data-y01-close]');
      const quantityButton = event.target.closest('[data-y08-quantity-change]');
      if (promoClose) {
        event.preventDefault();
        if (appPromo) appPromo.hidden = true;
        try {
          window.sessionStorage.setItem('nimall-y03-app-promo-dismissed', 'true');
        } catch (error) {
          void error;
        }
      } else if (open) {
        event.preventDefault();
        openPanel(open.dataset.y01Open);
      } else if (close) {
        event.preventDefault();
        closePanels();
      } else if (quantityButton) {
        event.preventDefault();
        const control = quantityButton.closest('[data-y08-quantity]');
        const input = control?.querySelector('input[name="updates[]"]');
        const form = quantityButton.closest('form');
        const delta = Number(quantityButton.dataset.y08QuantityChange || 0);
        if (!input || !form || !Number.isFinite(delta)) return;
        input.value = String(Math.max(Number(input.min || 0), Number(input.value || 0) + delta));
        window.clearTimeout(quantityTimer);
        quantityTimer = window.setTimeout(() => {
          const update = form.querySelector('.y08-cart-update');
          if (typeof form.requestSubmit === 'function' && update) form.requestSubmit(update);
          else if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }, 260);
      }

      const categoryButton = event.target.closest('[data-y01-category]');
      if (categoryButton) {
        cancelCategoryRestore();
        selectCategory(categoryButton.dataset.y01Category);
        loadActiveCategory();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePanels();
    });

    const requestedPanel = new URLSearchParams(window.location.search).get('y01_panel');
    if (requestedPanel === 'categories' || requestedPanel === 'account') openPanel(requestedPanel);
    else restoreCategoryNavigation();
  }

  mobile.addEventListener('change', initY01);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initY01, { once: true });
  else initY01();
})();
